import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

/**
 * Eligibility for Teamwork Collection (TWC) Plan Selection Modal during trial
 * (in trial, not invoiceable, can add payment details).
 * This is the no-PDE in trial case for the TWC collection.
 */
export function isEligibleForTWCTrialNoPDE(context: EditionAwarenessContextType): boolean {
	const {
		product,
		edition,
		isInCollection,
		isInTrial,
		invoiceableStatus,
		canAddPaymentDetails,
		userRoles,
	} = context;

	return Boolean(
		isEditionOneOf(edition, ['standard', 'premium']) &&
		isInCollection &&
		isProductOneOf(product, ['jira', 'confluence']) &&
		userRoles?.includes('BILLING_ADMIN') &&
		isInTrial &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		canAddPaymentDetails,
	);
}
